export const manifest = (() => {
function __memo(fn) {
	let value;
	return () => value ??= (value = fn());
}

return {
	appDir: "_app",
	appPath: "_app",
	assets: new Set(["favicon.png","smui.css"]),
	mimeTypes: {".png":"image/png",".css":"text/css"},
	_: {
		client: {"start":"_app/immutable/entry/start.BpopK1CE.js","app":"_app/immutable/entry/app.CbUQYmpE.js","imports":["_app/immutable/entry/start.BpopK1CE.js","_app/immutable/chunks/entry.CvXBI16c.js","_app/immutable/chunks/index-client.Dxzap11L.js","_app/immutable/chunks/runtime.B_Tq2JvT.js","_app/immutable/chunks/index.Cfv-du2c.js","_app/immutable/entry/app.CbUQYmpE.js","_app/immutable/chunks/preload-helper.C1FmrZbK.js","_app/immutable/chunks/runtime.B_Tq2JvT.js","_app/immutable/chunks/render.Djny2Eum.js","_app/immutable/chunks/svelte-head.C5vwEHCZ.js","_app/immutable/chunks/disclose-version.BrU4QSF1.js","_app/immutable/chunks/if.JF-hUsvQ.js","_app/immutable/chunks/svelte-component.C-n29HTO.js","_app/immutable/chunks/props.CDso3TR9.js","_app/immutable/chunks/this.C-8KbjFV.js","_app/immutable/chunks/index-client.Dxzap11L.js"],"stylesheets":[],"fonts":[],"uses_env_dynamic_public":false},
		nodes: [
			__memo(() => import('./nodes/0.js')),
			__memo(() => import('./nodes/1.js')),
			__memo(() => import('./nodes/2.js')),
			__memo(() => import('./nodes/3.js')),
			__memo(() => import('./nodes/4.js')),
			__memo(() => import('./nodes/5.js')),
			__memo(() => import('./nodes/6.js')),
			__memo(() => import('./nodes/7.js')),
			__memo(() => import('./nodes/8.js')),
			__memo(() => import('./nodes/9.js')),
			__memo(() => import('./nodes/10.js')),
			__memo(() => import('./nodes/11.js')),
			__memo(() => import('./nodes/12.js'))
		],
		routes: [
			{
				id: "/(app)/(main)",
				pattern: /^\/?$/,
				params: [],
				page: { layouts: [0,2,3,], errors: [1,,,], leaf: 5 },
				endpoint: null
			},
			{
				id: "/api/admin/functions/ensure-licenses",
				pattern: /^\/api\/admin\/functions\/ensure-licenses\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/admin/functions/ensure-licenses/_server.ts.js'))
			},
			{
				id: "/api/admin/functions/ensure-paid-users-premium",
				pattern: /^\/api\/admin\/functions\/ensure-paid-users-premium\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/admin/functions/ensure-paid-users-premium/_server.ts.js'))
			},
			{
				id: "/api/admin/functions/ensure-user-id",
				pattern: /^\/api\/admin\/functions\/ensure-user-id\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/admin/functions/ensure-user-id/_server.ts.js'))
			},
			{
				id: "/api/admin/functions/purge-user-accounts",
				pattern: /^\/api\/admin\/functions\/purge-user-accounts\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/admin/functions/purge-user-accounts/_server.ts.js'))
			},
			{
				id: "/api/admin/functions/request-reviews",
				pattern: /^\/api\/admin\/functions\/request-reviews\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/admin/functions/request-reviews/_server.ts.js'))
			},
			{
				id: "/api/admin/functions/send-license",
				pattern: /^\/api\/admin\/functions\/send-license\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/admin/functions/send-license/_server.ts.js'))
			},
			{
				id: "/api/bugs",
				pattern: /^\/api\/bugs\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/bugs/_server.ts.js'))
			},
			{
				id: "/api/portal/auth/login",
				pattern: /^\/api\/portal\/auth\/login\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/portal/auth/login/_server.ts.js'))
			},
			{
				id: "/api/portal/auth/logout",
				pattern: /^\/api\/portal\/auth\/logout\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/portal/auth/logout/_server.ts.js'))
			},
			{
				id: "/api/portal/devices",
				pattern: /^\/api\/portal\/devices\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/portal/devices/_server.ts.js'))
			},
			{
				id: "/api/portal/devices/[id]",
				pattern: /^\/api\/portal\/devices\/([^/]+?)\/?$/,
				params: [{"name":"id","optional":false,"rest":false,"chained":false}],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/portal/devices/_id_/_server.ts.js'))
			},
			{
				id: "/api/portal/installer/build",
				pattern: /^\/api\/portal\/installer\/build\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/portal/installer/build/_server.ts.js'))
			},
			{
				id: "/api/portal/installer/cancel",
				pattern: /^\/api\/portal\/installer\/cancel\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/portal/installer/cancel/_server.ts.js'))
			},
			{
				id: "/api/portal/installer/download",
				pattern: /^\/api\/portal\/installer\/download\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/portal/installer/download/_server.ts.js'))
			},
			{
				id: "/api/portal/installer/progress/listen",
				pattern: /^\/api\/portal\/installer\/progress\/listen\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/portal/installer/progress/listen/_server.ts.js'))
			},
			{
				id: "/api/prices",
				pattern: /^\/api\/prices\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/prices/_server.ts.js'))
			},
			{
				id: "/api/users",
				pattern: /^\/api\/users\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/users/_server.ts.js'))
			},
			{
				id: "/api/users/[id]",
				pattern: /^\/api\/users\/([^/]+?)\/?$/,
				params: [{"name":"id","optional":false,"rest":false,"chained":false}],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/users/_id_/_server.ts.js'))
			},
			{
				id: "/api/v2/verify/license",
				pattern: /^\/api\/v2\/verify\/license\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/v2/verify/license/_server.ts.js'))
			},
			{
				id: "/api/verify",
				pattern: /^\/api\/verify\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/verify/_server.ts.js'))
			},
			{
				id: "/api/verify/license",
				pattern: /^\/api\/verify\/license\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/verify/license/_server.ts.js'))
			},
			{
				id: "/(app)/(main)/checkout",
				pattern: /^\/checkout\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/(app)/(main)/checkout/_server.ts.js'))
			},
			{
				id: "/(app)/(main)/checkout/result",
				pattern: /^\/checkout\/result\/?$/,
				params: [],
				page: { layouts: [0,2,3,], errors: [1,,,], leaf: 6 },
				endpoint: null
			},
			{
				id: "/(app)/(main)/download",
				pattern: /^\/download\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/(app)/(main)/download/_server.ts.js'))
			},
			{
				id: "/(app)/(main)/features",
				pattern: /^\/features\/?$/,
				params: [],
				page: { layouts: [0,2,3,], errors: [1,,,], leaf: 7 },
				endpoint: null
			},
			{
				id: "/(app)/(main)/images/[filename]",
				pattern: /^\/images\/([^/]+?)\/?$/,
				params: [{"name":"filename","optional":false,"rest":false,"chained":false}],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/(app)/(main)/images/_filename_/_server.ts.js'))
			},
			{
				id: "/(app)/portal",
				pattern: /^\/portal\/?$/,
				params: [],
				page: { layouts: [0,2,4,], errors: [1,,,], leaf: 11 },
				endpoint: null
			},
			{
				id: "/(app)/portal/login",
				pattern: /^\/portal\/login\/?$/,
				params: [],
				page: { layouts: [0,2,4,], errors: [1,,,], leaf: 12 },
				endpoint: null
			},
			{
				id: "/(app)/(main)/pricing",
				pattern: /^\/pricing\/?$/,
				params: [],
				page: { layouts: [0,2,3,], errors: [1,,,], leaf: 8 },
				endpoint: null
			},
			{
				id: "/(app)/(main)/privacy",
				pattern: /^\/privacy\/?$/,
				params: [],
				page: { layouts: [0,2,3,], errors: [1,,,], leaf: 9 },
				endpoint: null
			},
			{
				id: "/(app)/(main)/releases/latest",
				pattern: /^\/releases\/latest\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/(app)/(main)/releases/latest/_server.ts.js'))
			},
			{
				id: "/(app)/(main)/releases/[version]/glimmr-setup.exe",
				pattern: /^\/releases\/([^/]+?)\/glimmr-setup\.exe\/?$/,
				params: [{"name":"version","optional":false,"rest":false,"chained":false}],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/(app)/(main)/releases/_version_/glimmr-setup.exe/_server.ts.js'))
			},
			{
				id: "/stripe/webhook",
				pattern: /^\/stripe\/webhook\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/stripe/webhook/_server.ts.js'))
			},
			{
				id: "/(app)/(main)/support",
				pattern: /^\/support\/?$/,
				params: [],
				page: { layouts: [0,2,3,], errors: [1,,,], leaf: 10 },
				endpoint: null
			}
		],
		matchers: async () => {
			
			return {  };
		},
		server_assets: {}
	}
}
})();

export const prerendered = new Set([]);

export const base = "";